import { ProjectJobDescription, JobDescriptionSummary } from "../Models";
import { APIURL } from "./config";

export type JobDescriptionWriteBody = {
  title: string;
  content: string;
  isActive: boolean;
  assigneeEmails?: string | null;
};

export async function GetJobDescriptions(token: string) {
  const res = await fetch(`${APIURL}/ProjectJobDescriptions`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const jobDescriptions: ProjectJobDescription[] = await res.json();
  return jobDescriptions;
}

export async function CreateJobDescription(
  body: JobDescriptionWriteBody,
  token: string
) {
  const res = await fetch(`${APIURL}/ProjectJobDescriptions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  const jobDescription: ProjectJobDescription = await res.json();
  return jobDescription;
}

export async function UpdateJobDescription(
  id: string,
  body: JobDescriptionWriteBody,
  token: string
) {
  const res = await fetch(`${APIURL}/ProjectJobDescriptions/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  const jobDescription: ProjectJobDescription = await res.json();
  return jobDescription;
}

export async function DeleteJobDescription(id: string, token: string) {
  await fetch(`${APIURL}/ProjectJobDescriptions/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function AttachJobDescriptionToRole(
  jobDescriptionId: string,
  roleId: string,
  token: string
) {
  const res = await fetch(
    `${APIURL}/ProjectJobDescriptions/${jobDescriptionId}/roles/${roleId}`,
    {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  if (!res.ok && res.status !== 409) {
    throw new Error(await res.text());
  }
}

export async function DetachJobDescriptionFromRole(
  jobDescriptionId: string,
  roleId: string,
  token: string
) {
  const res = await fetch(
    `${APIURL}/ProjectJobDescriptions/${jobDescriptionId}/roles/${roleId}`,
    {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  if (!res.ok && res.status !== 404) {
    throw new Error(await res.text());
  }
}

export async function GetCandidateProjectChoicesForRecruiter(
  candidateId: string,
  roleId: string,
  token: string
): Promise<string[]> {
  const res = await fetch(
    `${APIURL}/ProjectJobDescriptions/candidate-choices/${candidateId}/role/${roleId}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  if (!res.ok) return [];
  const jds: JobDescriptionSummary[] = await res.json();
  return jds.map((jd) => jd.title);
}

export async function SetJobDescriptionRoleActive(
  jobDescriptionId: string,
  roleId: string,
  isActive: boolean,
  token: string
) {
  const res = await fetch(
    `${APIURL}/ProjectJobDescriptions/${jobDescriptionId}/roles/${roleId}/is-active`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ isActive }),
    }
  );
  if (!res.ok) {
    throw new Error(await res.text());
  }
}
